<div class="menu" cdkMenu>
  <at-display-name class="p-sm" showAvatar showEmail hideMeBadge size="md" [user]="user()" />

  <hr />

  <a
    cdkMenuItem
    class="menu-item"
    routerLink="/profile"
    routerLinkActive="current"
    ariaCurrentWhenActive="page"
    [routerLinkActiveOptions]="{ exact: false }">
    <div class="icon icon-settings" aria-hidden="true"></div>
    <span>Profile</span>
  </a>
  <button cdkMenuItem class="menu-item" (click)="logout()">
    <div class="icon icon-log-out" aria-hidden="true"></div>
    <span>Sign out</span>
  </button>
</div>
